/**
 * Add to cart from the balance-bike age picker.
 *
 * Every product in this collection is a single variant — a colourway, nothing
 * else to choose — so there is no size step to skip and nothing is hidden by
 * adding straight from the band. The Liquid only renders a form when
 * `product.variants.size == 1`; anything with options renders a link to the
 * product page instead, so this handler can never add a variant the shopper did
 * not pick.
 *
 * The markup is a real <form> posting to /cart/add, so this is enhancement, not
 * function: with JavaScript off the browser posts the form and lands on the
 * cart page. The shopper is never stuck with a dead button.
 *
 * This listens for `click` on the button rather than `submit` on the form, and
 * that is not a style choice. Measured repeatedly on the preview theme: the
 * submit-based version fired two AddToCart pixel beacons for a single added
 * line, and this click-based one fires exactly one, as do the store's other add
 * buttons. That matters on a page built to receive paid traffic, because Meta
 * optimises delivery on that event and a doubled signal distorts it.
 *
 * The mechanism is not established. The obvious theory — that Shopify's pixel
 * watches form submissions to /cart/add as well as the XHR — does not survive
 * checking: main-product.liquid also intercepts a submit to /cart/add and fires
 * one beacon. So the rule here is empirical, not explained. If this file is
 * ever reworked, re-measure rather than assuming either shape is safe.
 *
 * One delegated listener on the section rather than one per button — the six
 * buttons are re-rendered whenever the section is, and per-element listeners
 * would silently stop working after that.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-lcap]');
  if (!root) return;

  root.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lcap-add] button');
    if (!button) return;

    var form = button.closest('[data-lcap-add]');
    var id = form && form.elements.id;
    if (!id || !id.value) return;

    /* Without the drawer helper there is nothing to enhance — let the click
       submit the form and land the shopper on the cart page. */
    if (typeof window.refreshCartDrawer !== 'function') return;

    event.preventDefault();
    if (button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    /* Form-encoded with a single id, which is the shape every other add button
       in this theme uses. There is no behavioural difference from the JSON
       `items:[…]` shape — both add exactly one line — so there is no case for
       this file having its own convention. */
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: 'id=' + encodeURIComponent(id.value) + '&quantity=1',
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add ' + response.status);
        /* refreshCartDrawer re-renders the drawer, updates the header bubble
           and announces the new count, so there is nothing else to sync. */
        return window.refreshCartDrawer({ open: true });
      })
      .then(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      })
      .catch(function () {
        /* Fall back to the real form post rather than leaving a disabled
           button and no explanation. */
        button.disabled = false;
        button.removeAttribute('aria-busy');
        form.submit();
      });
  });
})();
